import React, { useEffect } from 'react'
import Theme from '@/components/template/Theme'
import Layout from '@/components/layouts'
import { AuthProvider } from '@/auth'
import { useThemeStore } from '@/store/themeStore';
import PageContainer from '@/components/template/PageContainer';
import Copyright from '@/components/shared/Copyright';
import LandingContainer from '@/components/pages/Landing/components/LandingContainer';
import Container from '@/components/pages/Landing/components/LandingContainer';

// import '../locales'

function PublicLayout({children}: { children: React.ReactNode }) {
  const { layout, setLayout } = useThemeStore((state) => state)
  useEffect(() => {
    if (layout.type !== 'blank') {
      setLayout('blank');
    }
  }, []);

  return (
    <>
      <Theme>
        <AuthProvider>
          <Layout>
            <PageContainer footer={false} pageContainerType="gutterless">
              {children}

              <div id="site-footer" className="relative z-20">
                <Container className="relative">
                  <Copyright />
                </Container>
              </div>
            </PageContainer>
          </Layout>
        </AuthProvider>
      </Theme>
    </>
  )
}

export default PublicLayout
